<template>
  <div :class="['flex h-screen font-roboto', chromeActive ? 'overflow-hidden' : '']">
    <Sidebar />

    <div class="flex-1 flex flex-col overflow-hidden" data-chrome-column :style="chromeStyle">
      <EnvironmentStrip />
      <Header />

      <div
        :class="[
          'flex-1 flex flex-col',
          $route.meta.fullHeight ? 'overflow-hidden' : 'overflow-y-auto'
        ]"
        style="z-index: 0"
      >
        <div
          :class="[
            'container-dashboard',
            isCompactShell ? 'container-dashboard--compact' : '',
            $route.meta.fullHeight ? 'min-h-0 overflow-hidden flex flex-col !pt-0 !pb-[10px]' : ''
          ]"
        >
          <slot />
        </div>
        <Footer v-if="!$route.meta.hideFooter" />
      </div>
    </div>

    <ChangelogPanel />
  </div>
</template>

<script>
import { computed } from 'vue'
import Sidebar from '../Sidebar.vue'
import Header from '../Header.vue'
import Footer from '../Footer.vue'
import ChangelogPanel from '../Changelog/ChangelogPanel.vue'
import EnvironmentStrip from '../EnvironmentStrip.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useShellIsMobile } from '@/hooks/useShellIsMobile'
import { useDashboardChromeStore } from '@/pinia-store/useDashboardChromeStore'

const CHROME_TRANSITION = 'transform 180ms ease'
const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export default {
  components: {
    Sidebar,
    Header,
    Footer,
    ChangelogPanel,
    EnvironmentStrip
  },
  setup() {
    // Sem a flag, `useShellIsMobile` é o `innerWidth < 800` legado e o padding NÃO pode mudar:
    // a classe compacta (0.75rem nas laterais, spec §4.2) só existe com a flag do celular.
    const { flags } = useFeatureFlags()
    const shellIsMobile = useShellIsMobile()
    const isCompactShell = computed(() => flags.enabledDashboardMobile && shellIsMobile.value)
    // Headers que somem do /dashboard no celular v3 (S1 §2, dec. 67): a coluna sobe sem mudar
    // de altura (sem reflow). Só com a store ativada pela v3 (`hideHeight > 0`); fora dela,
    // nenhum estilo é aplicado.
    // A coluna fica h px mais alta enquanto ativa (altura constante: alternar só mexe no
    // transform), para não sobrar faixa vazia no rodapé ao subir; a raiz corta o excesso.
    const chrome = useDashboardChromeStore()
    const chromeActive = computed(() => chrome.hideHeight > 0)
    const transition = prefersReducedMotion() ? 'none' : CHROME_TRANSITION
    const chromeStyle = computed(() => {
      if (!chromeActive.value) return undefined
      const base = {
        height: `calc(100% + ${chrome.hideHeight}px)`,
        transition,
        '--chrome-visible-inset': `${chrome.visibleInset}px`
      }
      return chrome.hidden ? { ...base, transform: `translateY(-${chrome.hideHeight}px)` } : base
    })
    return { isCompactShell, chromeActive, chromeStyle }
  }
}
</script>

<style scoped>
.container-dashboard {
  flex: 1;
  padding: 1rem 2rem;
  background-color: white;
}
.container-dashboard--compact {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
</style>
